module.exports = __webpack_public_path__ + "static/media/abous-us-image-mobile.759708b1.png";